import * as actions from './actions'

const BusinessSettingsStore = {
  state: {},
  actions
}

export default BusinessSettingsStore
